export const PRODUTO = () => `/produto`;
